import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Box from '@mui/material/Box';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { DateTime } from 'luxon';
import CircularProgress from '@mui/material/CircularProgress';
import Autocomplete from '@mui/material/Autocomplete';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableFooter from '@mui/material/TableFooter';
import TableRow from '@mui/material/TableRow';
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';

import { createSearchParams, useSearchParams, useNavigate } from 'react-router-dom';
import { baseUrl, apiHelper } from 'helpers/util';

import RowBox from 'components/RowBox';
import SmallHeading from 'components/SmallHeading';
import ColumnBox from 'components/ColumnBox';
import { notify } from 'helpers/globalFunctions';

export default function Form(props) {
    const navigate = useNavigate();
    const [ balanceRows, setBalanceRows ] = useState([]);
    const [ startDate, setStartDate ] = useState(DateTime.now())
    const [ endDate, setEndDate ] = useState(DateTime.now())

    const [ fieldsVisibility, setFieldsVisibility ] = useState('All fields')

    const [ searchParams, setSearchParams ] = useSearchParams();
    const [ totalsRow, setTotalsRow ] = useState({});

    const loadBalanceReport = function() {
        const pFilters = [["timestamp", "between",
            [startDate.toFormat('yyyy-MM-dd'), endDate.toFormat('yyyy-MM-dd')]]]
        const apiParams = { "doctype": "FOLK Billing Order",
            "filters": JSON.stringify(pFilters),
            "fields": JSON.stringify(["name", "timestamp", "total_amount", "payment_mode"]),
            "order_by": "timestamp desc",
        }
        apiHelper.get({ "url": `${baseUrl}/.netlify/functions/erp_api`,
            "params": apiParams })
        .then(response => {
            if (response.status) {
                setBalanceRows(response.json.data);
                const totalsData = { 'total_amount': 0 }
                for (const r of response.json.data) {
                    totalsData['total_amount'] += r.total_amount
                    if (!totalsData[r.payment_mode]) { totalsData[r.payment_mode] = 0; }
                    totalsData[r.payment_mode] += r.total_amount;
                }
                setTotalsRow(totalsData);
            } else { console.log(response.json);
                notify.error({ "description": JSON.stringify(response.json) }); }
        })
    }

    useEffect(function() {
        loadBalanceReport();
    }, [])

    return (
        <Box sx={{ padding: '15px' }}>
            <SmallHeading>Past Orders</SmallHeading>
            <RowBox sx={{ width: '100%' }}>
                <Box sx={{ marginRight: '10px', marginTop: '15px' }}>
                    <LocalizationProvider dateAdapter={AdapterLuxon}>
                        <MobileDatePicker
                            onChange={(newValue) => { setStartDate(newValue); }}
                            value={startDate}
                            inputFormat="dd-MMM-yyyy"
                            mask=""
                            closeOnSelect={true}
                            disableMaskedInput={true}
                            renderInput={(params) => <TextField {...params}
                                label="Start Date" size="small" sx={{ width: '100%' }} />}
                        />
                    </LocalizationProvider>
                </Box>
                <Box sx={{ marginRight: '10px', marginTop: '15px' }}>
                    <LocalizationProvider dateAdapter={AdapterLuxon}>
                        <MobileDatePicker
                            onChange={(newValue) => { setEndDate(newValue); }}
                            value={endDate}
                            inputFormat="dd-MMM-yyyy"
                            mask=""
                            closeOnSelect={true}
                            disableMaskedInput={true}
                            renderInput={(params) => <TextField {...params}
                                label="End Date" size="small" sx={{ width: '100%' }} />}
                        />
                    </LocalizationProvider>
                </Box>

                <Button sx={{ marginRight: '10px', marginTop: '15px' }}
                    onClick={() => loadBalanceReport()} size="small"
                    variant="outlined">Search</Button>
            </RowBox>
            <Box sx={{ fontWeight: 'bold', color: '#60b246' }}>
                Total Amount: ₹ {totalsRow.total_amount}</Box>
            <Box sx={{ width: '100%', overflowX: 'scroll' }}>
                <Table size="small">
                    <TableBody>
                    {balanceRows.map((e) => (
                        <TableRow key={e.name}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 },
                                '& td, & th': { fontSize: '15px' } }}>
                                <TableCell sx={{ fontWeight: 'bold' }}>
                                    { DateTime.fromSQL(e.timestamp).toFormat('dd-MMM HH:mm') }</TableCell>
                                <TableCell align="right">
                                    <ColumnBox sx={{ alignItems: 'flex-end' }}>
                                        <span style={{ color: '#60b246', fontWeight: 'bold' }}>₹ {e.total_amount}</span>
                                        <span>{e.payment_mode}</span>
                                    </ColumnBox>
                                </TableCell>
                        </TableRow>
                    ))}
                    </TableBody>
                </Table>
            </Box>
        </Box>
    );
}
